<template>
  <v-sheet elevation="0" class="px-2 h85" v-if="user">
    <v-row class="justify-center mt-5">
      <v-col md="8" sm="10">
        <v-card elevation="4">
          <v-card-text>
            <v-row>
              <v-col cols="auto" class="ma-2">
                <v-avatar>
                  <v-img max-width="50" v-if="user.avatar" :src="user.avatar" />
                  <v-img
                    v-else
                    max-width="50"
                    contain
                    src="../assets/pine3_icon.svg"
                  />
                </v-avatar>
              </v-col>
              <v-col class="ma-2">
                <v-text-field
                  v-model="user.name"
                  label="Full Name"
                  :autocomplete="'false'"
                  :rules="rules.text"
                  hide-details
                  @input="changes = true"
                  required
                  dense
                >
                </v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="ma-2">
                <v-btn
                  small
                  outlined
                  color="info"
                  @click="passwordToggle = true"
                >
                  <v-icon class="mr-1" small>mdi-form-textbox-password</v-icon>
                  Reset Password
                </v-btn>
                <v-dialog v-model="passwordToggle" width="420">
                  <v-card>
                    <v-card-title> </v-card-title>
                    <v-card-text>
                      <h2 class="text-center mb-3 info--text">
                        <v-icon color="info" class="mr-1"
                          >mdi-form-textbox-password</v-icon
                        >
                        Reset Password
                      </h2>
                      <v-text-field
                        v-model="user.password"
                        label="Password"
                        :autocomplete="false"
                        :rules="rules.text && rules.pass"
                        :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="passShow ? 'text' : 'password'"
                        @click:append="passShow = !passShow"
                        hint="At least 8 characters & one letters or numbers"
                      >
                      </v-text-field>
                      <v-text-field
                        v-model="password2"
                        label="Password Validation"
                        :rules="rules.text && rules.pass"
                        :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="passShow ? 'text' : 'password'"
                        @click:append="passShow = !passShow"
                      >
                      </v-text-field>
                    </v-card-text>
                    <v-row>
                      <v-spacer> </v-spacer>
                      <v-col cols="auto">
                        <v-btn
                          class="ma-3"
                          :disabled="
                            !user.password ||
                            !user.password.length ||
                            password2 !== user.password
                          "
                          label="Save"
                          small
                          color="primary"
                          @click="updatePass"
                        >
                          <v-icon dark> mdi-content-save-move-outline </v-icon>
                          Update
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
            <!-- GROUP -->
            <v-row class="ma-1">
              <!-- <v-col cols="auto">
                  <v-avatar>
                    <v-img max-width="50" :src="group.avatar" />
                  </v-avatar> </v-col
                > -->
              <v-col>
                <v-text-field
                  :value="group.name"
                  label="Group Name"
                  :rules="rules.text"
                  required
                  disabled
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-select
                  :items="packages"
                  label="Pine3 Plan"
                  v-model="group.package"
                  @input="changes = true"
                  :disabled="role > roleType.SUPER_ADMIN"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  :items="locales"
                  label="Locale"
                  v-model="group.locale"
                  @input="changes = true"
                  :disabled="role > roleType.ADMIN"
                  dense
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-card class="ma-1 pa-1" elevation="4" cols="6">
              <v-row class="ma-1">
                <v-col>
                  <AddList
                    v-model="group.contacts"
                    title="Contacts"
                    icon="card-account-mail"
                    outlined
                    :disabled="role > roleType.ADMIN"
                    @changed="changed"
                    :fields="[
                      { type: 'text', name: 'name', label: 'Name' },
                      { type: 'text', name: 'val', label: 'Email' },
                    ]"
                  />
                </v-col>
                <v-divider vertical> </v-divider>
                <v-col>
                  <AddList
                    v-model="group.labels"
                    title="Environments/Labels"
                    icon="label"
                    :disabled="role > roleType.ADMIN"
                    @changed="changed"
                    :fields="[
                      {
                        type: 'text',
                        name: 'name',
                        label: 'Add new label',
                      },
                    ]"
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-row>
              <v-spacer> </v-spacer>
              <v-col cols="auto">
                <v-btn
                  class="ma-3"
                  :disabled="!valid"
                  label="Save"
                  :loading="loading"
                  color="success"
                  @click="save"
                >
                  <v-icon dark> mdi-content-save </v-icon> Save
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

// import Contacts from "@/components/Contacts.vue";
import AddList from "@/components/AddList.vue";
import { Group, RoleType, SelectItem, User } from "../types";
import { validations, updateObj, cloneObj, locales } from "../utils";

export default Vue.extend({
  name: "PreferencesView",
  components: { AddList },
  data() {
    return {
      tab: "user",
      rules: {
        text: [validations.empty],
        email: [validations.email],
        pass: [validations.password.len, validations.password.strength],
      },
      changes: false,
      loading: false,
      password2: "",
      passShow: false,
      passwordToggle: false,
      error: { type: "", msg: "" },
      roleType: RoleType,
    };
  },
  props: {
    outerRoute: VueTypes.string,
  },
  computed: {
    valid(): boolean {
      const valid: boolean =
        (this.user?.name?.length > 0 &&
          this.user?.email?.length > 0 &&
          this.changes) ||
        false;
      return valid;
    },
    self(): boolean {
      return this.$store.getters["Users/isSelf"];
    },
    role(): number {
      return this.$store.getters["Users/getRole"];
    },
    user(): User {
      const user: User = this.$store.getters["Users/getUser"];
      this.$store.commit("setTitle", `User Preferences`);
      return user;
    },
    packages(): SelectItem[] {
      return this.$store.getters.getPackages;
    },
    locales() {
      return locales || [];
    },
    group: {
      get(): Group {
        const group = this.$store.getters["Groups/getCurrentGroup"];
        if (!Object.keys(group).length) {
          this.$store.dispatch("Groups/fetchCurrentGroup", this.user.group);
        }
        return group;
      },
      set(group: Group) {
        this.$store.commit("Groups/setCurrentGroup", group);
      },
    },
  },
  methods: {
    async save() {
      this.loading = true;
      const req = await this.$store.dispatch("Users/saveUserPreferences", {
        user: this.user,
        group: this.group,
      });
      if (req.error) {
        this.error = req.error;
      }
      this.loading = false;
      this.changes = false;
    },
    async fetchGroups() {
      await this.$store.dispatch("Users/fetchGroups", this.groupsFilter);
    },
    updatePass() {
      this.$store.dispatch("Users/updatePassword", {
        id: this.user.id || this.user._id,
        password: this.user.password,
      });
      this.passwordToggle = false;
      this.password2 = "";
      this.user.password = "";
    },
    // changeGroup(option: { text: string; value: string }) {
    //   if (option) {
    //     const { text, value } = option;
    //     this.user.groupName = text;
    //     this.user.group = value;
    //     this.changes = true;
    //     // this.$store.commit("Users/setCurrentUserGroup", {
    //     //   groupName: text,
    //     //   group: value,
    //     // });
    //   }
    // },
    // search(e: Event) {
    //   const target =  e.target as HTMLTextAreaElement
    //   const text = target.value;
    //   if (text) {
    //     this.groupsFilter.search.name = text;
    //     this.fetchGroups();
    //   }
    // },
    // async save() {
    //   const req = await this.$store.dispatch("Groups/saveGroup", this.group);
    //   if (req.error) {
    //     this.error = req.error;
    //   }
    //   this.$router.push(this.outerRoute || "/groups");
    // },
    // addLabel() {
    //   if (this.searchLabel) {
    //     if (!this.group.labels || !this.group.labels.length) {
    //       this.group.labels = [];
    //     }
    //     this.group.labels.push(this.searchLabel);
    //     this.searchLabel = "";
    //     this.changes = true;
    //   }
    // },
    // rmLabel(i: number) {
    //   if (this.group.labels.length >= i + 1) {
    //     this.group.labels.splice(i, 1);
    //   }
    //   this.changes = true;
    // },
    changed(data: unknown) {
      if (data) {
        this.group = cloneObj(updateObj(this.group, data));
      }
      this.changes = true;
    },
  },
  watch: {
    passwordToggle(on: boolean) {
      if (on) {
        this.user.password = "";
      } else {
        delete this.user.password;
      }
    },
  },
  async mounted() {
    this.$store.commit("setGlobalLoader", true);
    await this.fetchGroups();
    this.$store.commit("setGlobalLoader");
  },
});
</script>
